// fix在页面右下角的
import customerIcon from '../../../../assets/images/customer_icon.png';
import './style.less';

const Customer = () => {
    const consultantClick = () => {
        window.open('https://affim.baidu.com/unique_31991888/chat?siteId=20131029&userId=31991888&siteToken=0eff073a09dd931b16f3bdcb82e3c756', '_blank');
    };
    return <img
        className="customer-icon"
        src={customerIcon}
        onClick={consultantClick}
    />;
};

export default Customer;